import SlideUpFooter from './SlideUpFooter';

export default SlideUpFooter;
